// Import Swiper React components
import React, { useCallback } from "react";
import SwiperCore, { Navigation } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import { NavButton } from "../buttons/NavButton";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";

SwiperCore.use([Navigation]);

export const PendingOrdersNav = ({ ordersRef }) => {
  const handlePrev = useCallback(() => {
    if (!ordersRef?.current) return;
    ordersRef?.current.swiper.slidePrev();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleNext = useCallback(() => {
    if (!ordersRef?.current) return;
    ordersRef?.current.swiper.slideNext();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <NavButton handleNext={handleNext} handlePrev={handlePrev} />;
};

const PendingOrdersSlider = ({ children, ordersRef }) => {
  return (
    <Swiper
      ref={ordersRef}
      spaceBetween={20}
      slidesPerView={3}
      breakpoints={{
        0: {
          slidesPerView: 1,
        },
        500: {
          slidesPerView: 2,
        },
        1000: {
          slidesPerView: 3,
        },
      }}
    >
      {React.Children.toArray(children)
        .flat(Infinity)
        .filter(Boolean)
        .map((child, index) => (
          <SwiperSlide key={index}>{child}</SwiperSlide>
        ))}
    </Swiper>
  );
};

export default PendingOrdersSlider;
